import * as Yup from 'yup';

export const defaultListSchema = Yup.object({
  Model: Yup.string().required('Model is required'),
  TypeId: Yup.string().required('Type is required'),
  StyleId: Yup.string().required('Style is required'),
  Notes: Yup.string(),
});
